import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import toast from "react-hot-toast";
import { Context } from "../../Context/ContextApi";
// import "bootstrap/dist/css/bootstrap.min.css";

const MyAddress = () => {
    const { getAddress, addresses, handleAddAddress } = useContext(Context)
    const [formData, setFormData] = useState({
        temp_name: "",
        temp_mobile: "",
        locality: "",
        pincode: "",
        city: "",
        state: "",
        country: "",
        address_type: "",
    });


    // Fetch addresses

    useEffect(() => {

        getAddress();
    }, [])

    // Handle input change
    const handleInputChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    // Add new address


    // Delete an address
    const handleDeleteAddress = (index) => {
        const id = toast.loading("Deleting address...");
        let config = {
            method: 'get',
            maxBodyLength: Infinity,
            url: `https://admin.tulikaarts.in/api/delete-address/${index}`,
            headers: {
                'Authorization': `Bearer ${window.localStorage.getItem("token")}`,
            },
        };

        axios.request(config)
            .then((response) => {
                console.log(JSON.stringify(response.data));
                setTimeout(() => {
                    toast.success(response.data.message, { id });
                    getAddress();
                }, 1000);
            })
            .catch((error) => {
                console.log(error);
            });
    };

    return (
        <div className="container" style={{ marginTop: "100px" }}>
            <div className="row">
                {/* Address List Section */}
                <div className="col-md-6">
                    <h3>Saved Addresses</h3>
                    {addresses.length === 0 ? (
                        <p className="text-muted">No addresses added yet.</p>
                    ) : (
                        <ul className="list-group">
                            {addresses.map((address, index) => (
                                <li key={index} className="list-group-item">
                                    <strong>{address.temp_name}</strong> ({address.address_type})
                                    <br />
                                    {address.locality}, {address.city}, {address.state}, {address.country}
                                    <br />
                                    Pincode: {address.pincode} | Mobile: {address.temp_mobile}
                                    <br />
                                    <button
                                        className="btn btn-danger btn-sm mt-2"
                                        onClick={() => handleDeleteAddress(address.id)}
                                    >
                                        Delete
                                    </button>
                                </li>
                            ))}
                        </ul>
                    )}
                </div>

                {/* Add Address Section */}
                <div className="col-md-6">
                    <h3>Add New Address</h3>
                    <div className="mb-2">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Name"
                            name="temp_name"
                            value={formData.temp_name}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div className="mb-2">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Mobile Number"
                            name="temp_mobile"
                            value={formData.temp_mobile}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div className="mb-2">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Locality"
                            name="locality"
                            value={formData.locality}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div className="mb-2">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Pincode"
                            name="pincode"
                            value={formData.pincode}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div className="mb-2">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="City"
                            name="city"
                            value={formData.city}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div className="mb-2">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="State"
                            name="state"
                            value={formData.state}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div className="mb-2">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Country"
                            name="country"
                            value={formData.country}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div className="mb-3">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Address Type (Home/Work)"
                            name="address_type"
                            value={formData.address_type}
                            onChange={handleInputChange}
                        />
                    </div>
                    <button className="btn btn-primary w-100" onClick={() => handleAddAddress({ formData })}>
                        Add Address
                    </button>
                </div>
            </div>
        </div>
    );
};

export default MyAddress;
